document.addEventListener('DOMContentLoaded', function () {
  var tiles = document.querySelectorAll('.editorial-catalog .editorial-video-tile');
  var dialog = document.getElementById('editorial-video-dialog');
  if (!tiles.length || !dialog) return;

  var player = dialog.querySelector('video');
  var title = dialog.querySelector('h2');
  var status = dialog.querySelector('[role="status"]');
  var trigger = null;

  function showError(message) {
    if (!dialog.open) return;
    status.textContent = message;
    status.hidden = false;
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      trigger = tile;
      title.textContent = tile.dataset.videoTitle;
      player.setAttribute('aria-label', tile.dataset.videoTitle);
      player.poster = tile.querySelector('img').src;
      player.src = tile.dataset.videoSrc;
      status.hidden = true;
      player.load();
      dialog.showModal();
      document.documentElement.classList.add('editorial-video-modal-open');
      player.play().catch(function (error) {
        if (error.name !== 'AbortError') {
          showError('This video could not start. Use the player’s play button to try again.');
        }
      });
    });
  });

  dialog.querySelector('.editorial-video-dialog-close').addEventListener('click', function () {
    dialog.close();
  });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) {
      dialog.close();
    }
  });
  // Native dialog handles Escape and focus trapping; every close path stops media.
  dialog.addEventListener('close', function () {
    player.pause();
    player.removeAttribute('src');
    player.load();
    document.documentElement.classList.remove('editorial-video-modal-open');
    if (trigger) trigger.focus({ preventScroll: true });
  });
  player.addEventListener('play', function () { status.hidden = true; });
  player.addEventListener('error', function () {
    showError('The video could not load. Please close the popup and try again.');
  });
});